import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber} from "page/util/helpers";

function Main() {
    const [contents, setContents] = useState([]);

    const requestSearch = (e) => {

        axios.get(`/admin/users/managers`)
            .then((res) => {
                setContents(res.data);
            });
    }

    const requestSave = (id) => {
        const ipName = document.getElementById("ip-name").value;
        const ipValue = document.getElementById("ip-value").value;
        if (ipName === "" || ipValue === "") {
            alert("아이피 정보를 입력해주세요.");
            return;
        }

        const params = new FormData();
        params.append("name", ipName);
        params.append("ip", ipValue);

        axios.post(`/admin/users/managers`, params, {
            headers: {'content-type': 'application/x-www-form-urlencoded'}
        })
        .then((res) => {
            document.location.reload();
        });
    }

    const requestDelete = (id) => {
        axios.delete(`/admin/users/managers/${id}`)
            .then((res) => {
                window.location.reload();
            });
    }

    useEffect(() => {
        requestSearch();
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">사업장관리 > 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>이름</label>

                                                <input id="ip-name" type="text" className="form-control"
                                                       style={{width: '150px'}}
                                                       // onChange={ e => {
                                                       //     searchParams.set('bizNumber', e.target.value);
                                                       //     setSearchParams(searchParams);
                                                       // }}
                                                       // onKeyDown={e => {
                                                       //     if (e.key === 'Enter') {
                                                       //         setPage(1);
                                                       //         requestSearch();
                                                       //     }
                                                       // }}
                                                       // value={bizNumber}
                                                       placeholder=''/>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>아이피</label>

                                                <input id="ip-value" type="text" className="form-control"
                                                       style={{width: '150px'}}
                                                       // onChange={ e=> {
                                                       //     searchParams.set('bizName', e.target.value);
                                                       //     setSearchParams(searchParams);
                                                       // }}
                                                       // onKeyDown={e => {
                                                       //     if (e.key === 'Enter') {
                                                       //         setPage(1);
                                                       //         requestSearch();
                                                       //     }
                                                       // }}
                                                       // value={bizName}
                                                       placeholder=''/>

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginRight: '10px'}}
                                                        onClick={ () => {
                                                            requestSave();
                                                        }}>
                                                    추가
                                                </button>

                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>이름</th>
                                                    <th>아이피</th>
                                                    <th>등록일</th>
                                                    <th>삭제</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.name}</td>
                                                                <td>{item.ip}</td>
                                                                <td>{item.createdAt}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-danger"
                                                                            onClick={ event => {requestDelete(item.id)}}>
                                                                        삭제
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Main;
